<div class="row" id="settings-permissions">
  <div class="flex flex-col col-12 mb-4">
    <h2 data-testid="permission-settings-title">{{ 'SYSTEM_SETTINGS.PERMISSIONS.PERMISSIONS_TITLE'| translate }}</h2>
  </div>
  <div class="col-12 mt-6 mb-4 pt-8 border-t">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="btn-update-permissions-settings" class="btn primary-btn" (click)="updatePermissionsSettings()">{{ 'SYSTEM_SETTINGS.PERMISSIONS.SAVE_CHANGES' | translate }}</button>
    </div>
  </div>
</div>
